import { Text } from '@cinch-labs/design-system'
import { FaqSection } from '@cinch-nx/data-storyblok'
import { StoryblokRenderer } from '@cinch-nx/landing-ui-shared'

import { storyblokComponents } from '../../data/storyblok-renderer-map'
import styles from './support-faqs.module.css'

export interface SupportFaqProps {
  faqs: FaqSection[]
}
const SupportFaqs = ({ faqs }: SupportFaqProps): JSX.Element => (
  <div className={styles.supportFaqs}>
    <Text element="h2" fontSize="xxl" fontWeight="bold">
      Got a Q? We’ve got the A
    </Text>
    <Text>
      Find everything from how we pick our cars to the different ways you can
      pay for one.
    </Text>
    <StoryblokRenderer block={faqs} components={storyblokComponents} />
  </div>
)

export default SupportFaqs
